<rb-loading-spinner *ngIf="dataLoadingSohTrajectories" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessageSohTrajectories && !dataLoadingSohTrajectories">
    <rb-callout type="warning">
        No data for "State of Health over time" chart.
    </rb-callout>
</div>
<div id="sohc-over-time-chart"></div>
<div class="p-2" *ngIf="!dataLoadingSohTrajectories && !errorMessageSohTrajectories">
    <div class="shaded-container ">
        Battery health trend and forecast. In general, the battery health declines over time, potentially reducing vehicle range.
    </div>
</div>